import { render, staticRenderFns } from "./CampusCreateModal.vue?vue&type=template&id=7f147284&"
import script from "./CampusCreateModal.vue?vue&type=script&lang=js&"
export * from "./CampusCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CampusCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports